<template>
  <v-container>
    <v-row justify-md="space-between">
      <v-col cols="12" md="auto">
        <v-btn
          @click="openFormDialog"
          class="accent shadow-4 px-8"
          color="success"
          large
          rounded
        >
          Añadir campaña
        </v-btn>
      </v-col>
    </v-row>

    <br />

    <!-- :search="search" -->
    <v-data-table
      show-expand
      single-expand
      :headers="headers"
      :items="externalClientCampaignList"
      item-key="id"
      :loading="isLoading"
      :options.sync="options"
      :server-items-length="totalItems"
      :footer-props="{
        'items-per-page-options': [15, 30, 50, 100],
      }"
    >
      <!-- <template v-slot:[`item.created_at`]="{ item }">
          <span>{{ dateFormat(item.created_at) }}</span>
        </template> -->

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="text--secondary">
          {{ item.observation || "Sin observaciones" }}
        </td>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            icon
            :color="hover ? 'accent' : 'blue-grey'"
            @click.stop="handleEdit(item)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-hover>

        <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            icon
            :color="hover ? 'error' : 'blue-grey'"
            @click.stop="handleDelete(item)"
          >
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
        </v-hover>
      </template>
    </v-data-table>

    <btnregister
      v-if="isOpenForm"
      :isActive="isOpenForm"
      :isEditMode="isEditMode"
      :dataToEdit="eventToEdit"
      @close:dialog="closeFormDialog"
    ></btnregister>
  </v-container>
</template>

<script>
import axios from "axios";
import btnregister from "./btnregister.vue";
// import btnupdate from '@/components/auth/user/btnupdate.vue';

export default {
  components: {
    btnregister,
    // btnupdate,
  },

  data: () => ({
    isLoading: false,
    calendarMode: false,
    isOpenForm: false,
    isEditMode: false,
    // For pagination
    totalItems: 0,
    options: {
      page: 1,
      itemsPerPage: 15,
    },
    // End for pagination
    externalClientCampaignList: [],
    calendarEvents: [],
    eventToEdit: {},
    search: "",
    headers: [
      {
        text: "Alias",
        align: "left",
        value: "alias",
        class: "primary--text",
        width: "20%",
      },
      {
        text: "Reintentos",
        align: "left",
        value: "retries",
        class: "primary--text",
        width: "10%",
      },
      {
        text: "Simultaneidad",
        value: "simultaneity",
        class: "primary--text",
        width: "10%",
      },
      {
        text: "Agente",
        value: "assignment_agent",
        class: "primary--text",
        width: "20%",
      },
      {
        text: "Cliente ext.",
        value: "external.name",
        class: "primary--text",
        width: "15%",
      },
      {
        text: "Acciones",
        value: "action",
        class: "primary--text",
        width: "15%",
        align: "left",
        sortable: false,
      },
    ],
  }),

  watch: {
    options: {
      handler() {
        this.getConfigExternal();
      },
      deep: true,
    },
  },

  created() {
    this.getConfigExternal();
  },

  methods: {
    openFormDialog() {
      this.isOpenForm = true;
    },

    handleEdit(item) {
      this.isEditMode = true;
      this.eventToEdit = item;
      this.openFormDialog();
    },

    async handleDelete(event) {
      const accessToken = localStorage.getItem("token");

      try {
        const confirmRequest = await this.$swalconfirm(
          "Confirmar",
          `Está seguro de eliminar esta configuración? Ésta acción no es reversible.`
        );
        if (confirmRequest.isConfirmed) {
          axios
            .delete(
              `${process.env.VUE_APP_ROOTAPI}/clients/configuration_external/${event.id}`,
              {
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                },
              }
            )
            .then((res) => {
              this.getConfigExternal();
              this.$snotify.success("Configuración eliminada", "¡Hecho!");
            })
            .catch((error) => {
              // console.error(error);
              this.$snotify.error(
                "Hubo un error al eliminar esta configuración.",
                "Error"
              );
            });
        }
      } catch (error) {
        this.$snotify.error("No se pudo eliminar la configuración.", "¡Error!");
        // console.error(error);
      }
    },

    closeFormDialog(data = false) {
      if (data && this.isEditMode)
        this.externalClientCampaignList = this.externalClientCampaignList.map(
          (el) => (el.id === data.id ? data : el)
        );
      if (data && !this.isEditMode)
        this.externalClientCampaignList = [
          ...this.externalClientCampaignList,
          data,
        ];
      this.isOpenForm = false;
      this.isEditMode = false;
      this.eventToEdit = {};
    },

    getConfigExternal() {
      this.isLoading = true;

      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      const accessToken = localStorage.getItem("token");

      axios
        .get(`${process.env.VUE_APP_ROOTAPI}/clients/configuration_external`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: {
            page,
            itemPerPage: itemsPerPage,
            // type: this.searchType,
            // value: this.search,
          },
        })
        .then((res) => {
          this.externalClientCampaignList = res.data.data;
          this.totalItems = res.data.total;
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style></style>
